class ServicePriceForm {
  get hideServices() {
    return this.selectedProduct === "AirPods";
  }
  get selectedProduct() {
    return this._selectedProduct;
  }
  set selectedProduct(product) {
    this._selectedProduct = product;
    this.onProductChange();
  }
  get selectedModel() {
    return this._selectedModel;
  }
  set selectedModel(model) {
    this._selectedModel = model;
    this.onModelChange();
  }
  get selectedServices() {
    return this._selectedServices;
  }
  set selectedServices(services) {
    this._selectedServices = services;
    this.onServiceChange();
  }
  constructor(section) {
    var _a;
    this.priceList = JSON.parse(
      ((_a = section.querySelector("script[data-price-list]")) == null ? void 0 : _a.innerHTML) || "{}"
    );
    this.productSelect = section.querySelector('select[name="product"]');
    this.productSelectWrapper = this.productSelect.closest(
      ".service-price-list__dropdown-container"
    );
    this.modelSelect = section.querySelector('select[name="model"]');
    this.modelSelectWrapper = this.modelSelect.closest(
      ".service-price-list__dropdown-container"
    );
    this.serviceDropdownWrapper = section.querySelector(
      ".service-price-list__dropdown-container--service"
    );
    this.serviceDropdown = this.serviceDropdownWrapper.querySelector(
      ".service-price-list__select-custom"
    );
    this.getEstimateBtn = section.querySelector(
      ".service-price-list__btn-estimate"
    );
    this.table = section.querySelector(".service-price-list__table");
    this.result = section.querySelector(".service-price-list__result");
    this.setProductOptions();
    this.setListners();
  }
  setProductOptions() {
    const products = Object.keys(this.priceList);
    const html = products.reduce(
      (html2, product) => html2 + `<option value="${product}">${product}</option>`,
      ""
    );
    this.productSelect.insertAdjacentHTML("beforeend", html);
  }
  setModelOptions() {
    const models = Object.keys(this.priceList[this.selectedProduct]);
    const html = models.reduce(
      (html2, model) => html2 + `<option value="${model}">${model}</option>`,
      ""
    );
    this.modelSelect.innerHTML = "<option disabled selected value>Select one</option>";
    this.modelSelect.insertAdjacentHTML("beforeend", html);
    this.modelSelect.removeAttribute("disabled");
  }
  setServiceOptions() {
    const services = Object.keys(this.priceList[this.selectedProduct][this.selectedModel]);
    if (this.hideServices) {
      this.selectedServices = services;
    } else {
      const html = services.reduce((html2, service) => {
        return html2 + `<label class="checkbox_container">
						<input type="checkbox" value="${service}" name="service">
						<span class="checkmark"></span>
						${service}
					</label>`;
      }, "");
      this.serviceDropdown.innerHTML = `<div class="service-price-list__option-list ${window.isAr && "service-price-list__option-list--ar"}">${html}</div>`;
      this.serviceDropdown.tabIndex = 0;
    }
  }
  onProductChange() {
    this.result.style.display = "none";
    this.productSelectWrapper.classList.add("service-price-list__dropdown-container--selected");
    this.modelSelectWrapper.classList.remove("service-price-list__dropdown-container--selected");
    this.selectedModel = "";
    this.setModelOptions();
    this.serviceDropdownWrapper.style.display = this.hideServices ? "none" : "block";
    this.serviceDropdown.innerHTML = "";
    this.serviceDropdown.tabIndex = -1;
  }
  onModelChange() {
    this.result.style.display = "none";
    this.selectedServices = [];
    if (this.selectedModel) {
      this.modelSelectWrapper.classList.add("service-price-list__dropdown-container--selected");
      this.setServiceOptions();
    }
    this.serviceDropdownWrapper.classList.remove(
      "service-price-list__dropdown-container--selected"
    );
  }
  onServiceChange() {
    var _a;
    this.result.style.display = "none";
    (_a = this.serviceDropdown.querySelector(".service-price-list__selected-values")) == null ? void 0 : _a.remove();
    this.getEstimateBtn.disabled = this.selectedServices.length ? false : true;
    if (this.selectedServices.length && !this.hideServices) {
      this.serviceDropdown.insertAdjacentHTML(
        "afterbegin",
        `<div class="service-price-list__selected-values">${this.selectedServices.join(
          ", "
        )}</div>`
      );
      this.serviceDropdownWrapper.classList.add("service-price-list__dropdown-container--selected");
    } else {
      this.serviceDropdownWrapper.classList.remove(
        "service-price-list__dropdown-container--selected"
      );
    }
  }
  setListners() {
    this.productSelect.addEventListener("change", (event) => {
      const target = event.target;
      this.selectedProduct = target.value;
    });
    this.modelSelect.addEventListener("change", (event) => {
      const target = event.target;
      this.selectedModel = target.value;
    });
    this.serviceDropdown.addEventListener("change", () => {
      const formData = new FormData(this.serviceDropdown);
      this.selectedServices = formData.getAll("service");
    });
    this.serviceDropdown.addEventListener("click", (event) => {
      event.stopPropagation();
      this.serviceDropdown.classList.add("service-price-list__select-custom--open");
    });
    window.addEventListener("click", () => {
      this.serviceDropdown.classList.remove("service-price-list__select-custom--open");
    });
    this.getEstimateBtn.addEventListener("click", () => {
      if (!this.selectedServices.length)
        return;
      this.calculateResult();
    });
  }
  calculateResult() {
    const result = {};
    for (const service of this.selectedServices) {
      result[service] = this.priceList[this.selectedProduct][this.selectedModel][service];
    }
    const html = Object.entries(result).map(([service, price]) => {
      return `<div class="service-price-list__row">
					<div class="service-price-list__service">${service}</div>
					<div class="service-price-list__price">${price}</div>
				</div>`;
    }).join("");
    this.table.innerHTML = html;
    this.result.style.display = "block";
  }
}
const sections = document.querySelectorAll(".service-price-list");
for (const section of sections) {
  new ServicePriceForm(section);
}
